import { Row, ChartArea } from '@repo/ui/components'
import type { ProjectsCardItemProps } from './projects.card-item.types'
import { useProjectPriceChartSnapshot } from '@repo/services'
import { useMemo } from 'react'

export const ProjectsCardItemChart = ({ project }: ProjectsCardItemProps) => {
  const { data } = useProjectPriceChartSnapshot({
    token: project.token ?? '',
  })

  const areaColor = useMemo(() => {
    return project.price?.priceRange24h?.deltaPercent &&
      project.price?.priceRange24h?.deltaPercent < 0
      ? 'var(--color-negative-main)'
      : project.price?.priceRange24h?.deltaPercent === 0
        ? 'var(--color-neutral-main)'
        : 'var(--color-positive-main)'
  }, [project.price?.priceRange24h?.deltaPercent])
  return (
    <Row className='gap-2xs h-[32px] w-full'>
      {data?.data?.data && !!project.price?.priceRange24h?.deltaPercent && (
        <ChartArea
          config={{ '#3B82F6': { label: 'Price' } }}
          areaConfig={{
            stroke: areaColor,
            fill: areaColor,
            fillOpacity: 0.2,
          }}
          id={project.token ?? ''}
          hideTooltip={true}
          hideGrid={true}
          hideXAxis={true}
          hideYAxis={true}
          className='h-[52px] w-full'
          data={
            data?.data?.data?.map((item) => ({
              name: item.time?.toString() ?? '',
              value: item.price ?? 0,
            })) || []
          }
        />
      )}
    </Row>
  )
}
